export default __webpack_public_path__ + "static/magician_ring-3fe63c00328f940e1c106713a12edf20.png";